import script from "./ModalConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./ModalConfirm.vue?vue&type=style&index=0&id=03a2c732&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03a2c732"]])

export default __exports__